import React from "react";
import {observable, toJS} from 'mobx';
import {observer} from 'mobx-react';

import {DatePicker, Row, Col, Input, Select, Radio, AutoComplete, Button} from 'antd';



const Option = Select.Option;

class CustomerTypeSelect extends React.Component {

  static TYPE_MODE_AGENT = 0;
  static TYPE_MODE_USER = 1;

  static TYPE_AGENT_ALL = '全部下线';
  static TYPE_AGENT_OWN = '直属下线';


  static TYPE_USER_ALL = '全部下线会员';
  static TYPE_USER_OWN = '直属会员';
  static TYPE_USER_NEW = '今日新增会员';

  static getTypeId(type) {
    if (type == CustomerTypeSelect.TYPE_AGENT_ALL)
      return 1;
    else if (type == CustomerTypeSelect.TYPE_AGENT_OWN)
      return 2;
    else if (type == CustomerTypeSelect.TYPE_USER_ALL)
      return 0;
    else if (type == CustomerTypeSelect.TYPE_USER_OWN)
      return 1;
    else if (type == CustomerTypeSelect.TYPE_USER_NEW)
      return 2;
    return -1;
  }

  static getTypeName(mode,typeId) {

    if (mode == CustomerTypeSelect.TYPE_MODE_AGENT)
    {
      if (typeId == 2)
      {
        return CustomerTypeSelect.TYPE_AGENT_OWN
      }
      else
      {
        return CustomerTypeSelect.TYPE_AGENT_ALL
      }
    }
    else
    {
      if (typeId == 2)
      {
        return CustomerTypeSelect.TYPE_USER_NEW
      }
      else if (typeId == 1)
      {
        return CustomerTypeSelect.TYPE_USER_OWN
      }
      else
      {
        return CustomerTypeSelect.TYPE_USER_ALL
      }
    }
  }



  render() {

    let children = [];

    if (this.props.typeMode == CustomerTypeSelect.TYPE_MODE_AGENT)
    {
      let element1 = <Option key={CustomerTypeSelect.TYPE_AGENT_ALL}>{CustomerTypeSelect.TYPE_AGENT_ALL}</Option>
      children.push(element1)
      let element2 = <Option key={CustomerTypeSelect.TYPE_AGENT_OWN}>{CustomerTypeSelect.TYPE_AGENT_OWN}</Option>
      children.push(element2)
    }
    else
    {
      let element1 = <Option key={CustomerTypeSelect.TYPE_USER_ALL}>{CustomerTypeSelect.TYPE_USER_ALL}</Option>
      children.push(element1)
      let element2 = <Option key={CustomerTypeSelect.TYPE_USER_OWN}>{CustomerTypeSelect.TYPE_USER_OWN}</Option>
      children.push(element2)
      let element3 = <Option key={CustomerTypeSelect.TYPE_USER_NEW}>{CustomerTypeSelect.TYPE_USER_NEW}</Option>
      children.push(element3)
    }

    return (
      <Select
        style={this.props.style}
        size={'small'}
        defaultValue={this.props.defaultValue}
        value={this.props.defaultValue}
        onChange={this.props.onChange}
        >
        {children}
      </Select>
    )

  }
}

export default CustomerTypeSelect;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Common/CustomerTypeSelect.jsx